export const getDescriptionImage = (serviceTitle) => {
  const imageMap = {
    "Верстка сайтов": "/yslygi1.svg",
    "Одностраничный сайт": "/yslygi2.svg",
    "Корпоративные сайты": "/yslygi3.svg",
    "Интернет-магазины": "/yslygi4.svg",
    "Мобильные приложения": "/yslygi5.svg",
    "Веб-приложения": "/yslygi6.svg",
    "UI/UX Дизайн": "/yslygi7.svg",
    "Редизайн сайтов": "/yslygi8.svg",
    "Техническая поддержка": "/yslygi9.svg",
    "Автоматизация бизнеса": "/yslygi10.svg",
    "Хостинг и DevOps": "/yslygi11.svg",
  };
  return imageMap[serviceTitle] || "/services/default.jpg";
};

export const getServiceDescriptionTitle = (serviceTitle) => {
  const descriptionTitles = {
    "Верстка сайтов": "Профессиональная верстка сайтов",
    "Корпоративные сайты": "Разработка корпоративных сайтов",
    "Интернет-магазины": "Создание интернет-магазинов",
    "Мобильные приложения": "Разработка мобильных приложений",
    "Веб-приложения": "Создание веб-приложений",
    "UI/UX Дизайн": "UI/UX дизайн интерфейсов",
    "Редизайн сайтов": "Редизайн и модернизация сайтов",
    "Техническая поддержка": "Техническая поддержка сайтов",
    "Автоматизация бизнеса": "Автоматизация бизнес-процессов",
    "Хостинг и DevOps": "Хостинг и DevOps услуги",
  };
  return descriptionTitles[serviceTitle] || "Описание услуги";
};
